import { Link } from "react-router-dom";
import MarketingNav from "../../components/marketing/MarketingNav";
import MarketingFooter from "../../components/marketing/MarketingFooter";
import {
  Package, Wrench, ClipboardList, BookOpen, Wallet,
  FileText, Image, BarChart3, Users, ShieldCheck, Bell, Ship,
} from "lucide-react";

const FEATURES = [
  { icon: Ship, title: "Multi-yacht profiles", copy: "Each yacht keeps its own crew, inventory, jobs, ledger and documents — switchable in one click." },
  { icon: Package, title: "Inventory", copy: "Spare parts, consumables, safety gear, water toys. Photos, part numbers, suppliers, low-stock alerts." },
  { icon: Wrench, title: "Maintenance & service history", copy: "Open, in-progress, waiting-parts, completed. Recurring jobs at engine hour intervals." },
  { icon: ClipboardList, title: "Deckhand tasks", copy: "Daily/weekly checklists with photo-completion proof and priority." },
  { icon: BookOpen, title: "Digital logbook", copy: "Daily, trip, engine, fuel, guest and incident logs — all exportable to PDF." },
  { icon: Wallet, title: "Petty cash & approvals", copy: "Multi-currency entries, receipt uploads, captain/accountant approval workflow." },
  { icon: FileText, title: "Documents & expiry alerts", copy: "Insurance, registration, certificates, manuals. Expiry alerts 30 days out." },
  { icon: Image, title: "Photo evidence", copy: "Before / after on every job. Tag photos to inventory, tasks and maintenance." },
  { icon: BarChart3, title: "Reports & exports", copy: "Monthly expenses, service history, low-stock, crew activity — CSV / PDF." },
  { icon: Users, title: "Roles & permissions", copy: "Owner, captain, engineer, deckhand, accountant, service provider — granular access." },
  { icon: ShieldCheck, title: "Audit ready", copy: "Every action is logged with who, when, and what. Resale-grade history." },
  { icon: Bell, title: "Notifications", copy: "In-app + email today; mobile push and WhatsApp on the roadmap." },
];

export default function Features() {
  return (
    <div className="bg-white text-ink">
      <MarketingNav />

      <section className="py-20 border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="text-xs tracking-[0.2em] uppercase font-semibold text-zinc-500 mb-3">
              Features
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.05] font-medium">
              Twelve modules.<br />
              <span className="text-zinc-400">One control center.</span>
            </h1>
          </div>
          <div className="md:col-span-5 text-zinc-600 leading-relaxed">
            Every module connects: a maintenance job can pull parts from inventory,
            attach photos, charge petty cash, and update the logbook — automatically.
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => (
            <div key={f.title} className="rounded-lg border border-zinc-200 bg-white p-6" data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z]/g,"-")}`}>
              <f.icon className="h-5 w-5 text-ink" />
              <div className="mt-5 font-display text-xl font-medium">{f.title}</div>
              <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{f.copy}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-zinc-50 border-t border-zinc-200">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center md:text-left flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight">Ready to run your yacht like a flagship?</h3>
            <p className="text-zinc-600 mt-2">Seavanto is currently in private beta — invitation only.</p>
          </div>
          <Link
            to="/request-access"
            data-testid="features-cta"
            className="inline-flex items-center justify-center rounded-md bg-ink text-white px-5 py-3 text-sm font-medium"
          >
            Request access
          </Link>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
